import api from './'

export default {

    /**
     * Get allowances
     * @param params
     */
    get(params = {}) {
        return api
            .get('/allowances', {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Create an allowance
     * @param type
     * @param data
     */
    create(type, data) {
        return api
            .post(`/allowances/${type}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Get an allowance
     * @param allowanceId
     * @param params
     */
    show(allowanceId, params) {
        return api
            .get(`/allowances/${allowanceId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Cancel an allowance
     * @param allowanceId
     * @param data
     */
    cancel(allowanceId, data) {
        return api
            .post(`/allowances/${allowanceId}/cancel`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Stop an allowance
     * @param allowanceId
     * @param data
     */
    stop(allowanceId, data) {
        return api
            .post(`/allowances/${allowanceId}/stop`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Decline an allowance
     * @param allowanceId
     * @param data
     */
    decline(allowanceId, data) {
        return api
            .post(`/allowances/${allowanceId}/decline`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Confirm an allowance
     * @param allowanceId
     * @param data
     */
    confirm(allowanceId, data) {
        return api
            .post(`/allowances/${allowanceId}/confirm`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Download statement PDF
     * @param allowanceId
     * @param params
     */
    download(allowanceID, params) {
        return api
            .get(`/allowances/${allowanceID}/pdf`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Simulate an allowance
     * @param type
     * @param data
     */
    simulate(type, data) {
        return api
            .post(`/allowances/simulate/${type}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Switch payment methods
     * @param allowanceId
     * @param data
     */
    switchPaymentMethods(allowanceId, data) {
        return api
            .post(`/allowances/${allowanceId}/switchPaymentMethods`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Update allowance
     * @param allowanceID
     * @param data
     * @param config
     */
    update(allowanceID, data, config) {
        return api
            .patch(`/allowances/${allowanceID}`, data, config)
            .then(response => {
                return response.data
            })
    },

}
